import type { CURRENCY } from './constants';

interface SharedProps {
  value: number;
  trailingZeros?: number;
  minimumTrailingZeros?: number;
  showSign?: boolean;
}

interface CurrencyProps extends SharedProps {
  type: 'currency';
  currencyCode: CURRENCY;
}

interface PercentOrPlainProps extends SharedProps {
  type: 'percent' | 'plain';
}

export type NumberFormatterProps = CurrencyProps | PercentOrPlainProps;

const NON_BREAKING_SPACE = '\u00A0';

export const formatNumber = (locale: Intl.LocalesArgument, props: NumberFormatterProps): string => {
  const { value, trailingZeros = 2, minimumTrailingZeros, showSign } = props;
  const formattedValue = new Intl.NumberFormat(locale, {
    minimumFractionDigits: minimumTrailingZeros ?? Math.min(trailingZeros, 2),
    maximumFractionDigits: trailingZeros,
    signDisplay: showSign ? 'always' : undefined,
  }).format(Number(value));

  if (props.type === 'currency') {
    return formattedValue + NON_BREAKING_SPACE + props.currencyCode;
  }

  if (props.type === 'percent') {
    return `${formattedValue + NON_BREAKING_SPACE}%`;
  }

  return formattedValue;
};
